// Cores para status
export function color(creditor_status_history) {
  if (!creditor_status_history) return "";
  const status = creditor_status_history.status;
  switch (status) {
    case "UNCHECKED": return "grey";
    case "RUNNING": return "yellow";
    case "OK": return "green";
    case "PROBLEM": return "red";
    default: return "grey";
  }
}

export function colorSync(syncProposal_status_history) {
  if (!syncProposal_status_history || !syncProposal_status_history.sync_status) return "";
  const status = syncProposal_status_history.sync_status;
  switch (status) {
    case "OK": return "green";
    case "ALERT": return "yellow";
    case "ERROR": return "red";
    default: return "grey";
  }
}

export function colorProposal(syncProposal_status_history) {
  if (!syncProposal_status_history || !syncProposal_status_history.generate_proposal) return "";
  const status = syncProposal_status_history.generate_proposal;
  switch (status) {
    case "OK": return "green";
    case "ALERT": return "yellow";
    case "ERROR": return "red";
    default: return "grey";
  }
}

// Cor por valor numérico
export function setColor(value) {
  if (value > 0) {
    if (value * 100 < 90) return "";
    if (value * 100 > 100) return "text-red";
    return "text-orange";
  }
  return "";
}

// Ícones para status
export function icon(creditor_status_history) {
  if (!creditor_status_history) return "";
  const status = creditor_status_history.status;
  switch (status) {
    case "UNCHECKED": return "mdi-dots-horizontal";
    case "RUNNING": return "loading";
    case "OK": return "check";
    case "PROBLEM": return "mdi-alert-circle-outline";
    default: return "mdi-dots-horizontal";
  }
}

// Data formatada (DD/MM/YYYY)
export function dia(creditor_status_history) {
  const dataHora = creditor_status_history ? creditor_status_history.datetime : null;
  if (!dataHora) return "Aguardando...";
  return dataHora.split("T")[0].split("-").reverse().join("/");
}

// Hora formatada (HH:MM:SS)
export function hora(creditor_status_history) {
  const dataHora = creditor_status_history ? creditor_status_history.datetime : null;
  if (!dataHora) return "";
  const [hora, minutos, segundos] = dataHora.split("T")[1].split(":");
  return `${hora}:${minutos}:${segundos}`;
}

// Título do status do credor
export function titleCreditorStatusHistory(creditor_status_history) {
  if (!creditor_status_history) return "";
  const { status, type } = creditor_status_history;
  if (!["UNCHECKED", "RUNNING", "OK", "PROBLEM"].includes(status)) return "";

  switch (type) {
    case "C": return "Consolidação";
    case "I": return "Importação";
    case "B": return "Blacklist";
    default: return "";
  }
}

// Informações adicionais
export function infoStatusHistory(creditor_status_history) {
  return creditor_status_history ? creditor_status_history.info : {};
}

export function infoSyncProposal(syncProposal_status_history) {
  return syncProposal_status_history ? syncProposal_status_history.info : {};
}
